import React, { useEffect } from 'react';
import { Container, Stack } from '@mui/material';

import { Page } from '../../../components';
import HeaderBreadcrumbs from '../../../components/header-breadcrumbs';
import { DrawOnMap } from '.';
import drawOnMapConstants from './drawOnMapConstants';
import { GeofenceService } from '../../../services/geofence.service';
import { isRequestCanceled } from '../../../http';
import { toast } from 'react-toastify';

// DrawOnMapScreen presents and contains the map that can be drawn on, to make a geofence
export function DrawOnMapScreen() {
    useEffect(() => {
        const controller = new AbortController();

        (async () => {
            try {
                await Promise.all([
                    GeofenceService.fetchGeofences(undefined, controller.signal),
                    GeofenceService.fetchGeoPhones(undefined, controller.signal),
                ]);
            } catch (error) {
                if (isRequestCanceled(error)) {
                    return;
                }

                console.error('Failed to load geofence data for draw-on-map:', error);
                toast('Unable to load geofence data. Please refresh and try again.', {
                    autoClose: 2000,
                    type: 'error',
                });
            }
        })();

        return () => controller.abort();
    }, []);

    return (
        <>
            <Page title={drawOnMapConstants.drawOnMapTitle}>
                <Container maxWidth={false}>
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <HeaderBreadcrumbs
                            heading="Geofence"
                            links={[]}
                            activeLast={false}
                        />
                    </Stack>
                </Container>

                <Container maxWidth={false} sx={{ mt: 1 }}>
                    <DrawOnMap />
                </Container>
            </Page>
        </>
    );
}
